// extracted by mini-css-extract-plugin
module.exports = {"Topnav":"topnav_Topnav__tZG1h","ProfileBtn":"topnav_ProfileBtn__3LiJw"};